
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/universities/slug-body",
      function () {
        return require("private-next-pages/universities/slug-body.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/universities/slug-body"])
      });
    }
  